import moment from "moment";

export const examGradeTypeMixin = {
  computed: {
    computedExamGradeTypeDescription() {
      return this.examGradeType[this.computedExamGradeType];
    },
    computedExamGradeType() {
      let graceMark = parseInt(this.editedItem.graceMark || 0, 10);
      console.log("graceMark", graceMark);
      let theoreticalMark = parseInt(this.editedItem.theoryMark || 0, 10);
      let theoreticalGraceMark = parseInt(
        this.editedItem.theoreticalGraceMark || 0,
        10
      );
      console.log("theoreticalGraceMark", theoreticalGraceMark);
      let oralGraceMark = parseInt(this.editedItem.oralGraceMark || 0, 10);

      let practicalAveMark = this.getAverageMark(
        this.editedItem.practicalMark1,
        this.editedItem.practicalMark2,
        this.editedItem.practicalMark3,
        this.editedItem.practicalMark4,
        this.editedItem.practicalMark5
      );

      let oralAveMark = this.getAverageMark(
        this.editedItem.oralMark1,
        this.editedItem.oralMark2,
        this.editedItem.oralMark3
      );

      if (this.editedItem.gradeLevel == 1) {
        let totalMark =
          practicalAveMark + oralAveMark + oralGraceMark + graceMark;
        console.log("grade 1 totalMark", totalMark);
        return this.getGradeType(totalMark);
      }
      if (this.editedItem.isRetry) {
        let totalMark = theoreticalMark + theoreticalGraceMark + graceMark;
        let examGradeType = this.getGradeType(totalMark);
        if (examGradeType === 1 || examGradeType === 2 || examGradeType === 3) {
          examGradeType = 4;
        }
        return examGradeType;
      }

      let totalPracticalOral = practicalAveMark + oralAveMark + oralGraceMark;
      let totalTheoretical = theoreticalMark + theoreticalGraceMark;
      let totalMark =
        Math.round(totalPracticalOral * 0.6) +
        Math.round(totalTheoretical * 0.4) +
        graceMark;

      if (totalMark === 0) {
        return 0;
      }
      if (totalTheoretical < 45 && totalPracticalOral >= 45) {
        return 5;
      }
      console.log("totalPracticalOral", totalPracticalOral);
      if (totalPracticalOral < 45) {
        return 6;
      }
      return this.getGradeType(totalMark);
    },
  },
  methods: {
    getGradeType(mark) {
      if (!mark || mark === 0) return 0;

      if (mark >= 75) return 1;
      if (mark >= 65) return 2;
      if (mark >= 55) return 3;
      if (mark >= 45) return 4;
      return 6;
    },
    getAverageMark(mark1, mark2, mark3, mark4, mark5) {
      let counter = 0;
      let markSum = 0;

      if (mark1) {
        counter++;
        markSum += parseInt(mark1, 10);
      }
      if (mark2) {
        counter++;
        markSum += parseInt(mark2, 10);
      }
      if (mark3) {
        counter++;
        markSum += parseInt(mark3, 10);
      }
      if (mark4) {
        counter++;
        markSum += parseInt(mark4, 10);
      }
      if (mark5) {
        counter++;
        markSum += parseInt(mark5, 10);
      }
      if (counter > 0) {
        return Math.round(markSum / counter);
      }
      return 0;
    },
    editItem(item) {
      this.editedItem = Object.assign({}, item);

      let theoreticalMark = parseInt(item.theoryMark || 0, 10);
      let theoreticalGraceMark = parseInt(item.theoreticalGraceMark || 0, 10);
      let schoolYearId = parseInt(item.schoolYearId);

      let practicalAveMark = this.getAverageMark(
        this.editedItem.practicalMark1,
        this.editedItem.practicalMark2,
        this.editedItem.practicalMark3,
        this.editedItem.practicalMark4,
        this.editedItem.practicalMark5
      );

      let oralAveMark = this.getAverageMark(
        this.editedItem.oralMark1,
        this.editedItem.oralMark2,
        this.editedItem.oralMark3
      );

      let oralGraceMark = parseInt(this.editedItem.oralGraceMark || 0, 10);

      let totalTheoretical = theoreticalMark + theoreticalGraceMark;
      let totalPractical = practicalAveMark + oralAveMark + oralGraceMark;
      let calcTheoretical = Math.round(totalTheoretical * 0.4);
      let calcPractical = Math.round(totalPractical * 0.6);

      //vs changes 12/4/2022 Grade 1 Changes
      if (this.editedItem.gradeLevel == 1) {
        calcPractical = Math.round(totalPractical);
      }

      //vs changes 12/4/2022 Grade 2 Changes
      if (this.editedItem.gradeLevel == 2 && schoolYearId > 35 && schoolYearId != 37) {
        calcPractical = Math.round(totalPractical);
      }


      this.editedItem.totalTheoryMark = totalTheoretical;
      this.editedItem.totalPracticalMark = totalPractical;
      this.editedItem.totalMark = calcTheoretical + calcPractical;

      this.editedItem.calcTheoretical = calcTheoretical;
      this.editedItem.calcPractical = calcPractical;


      this.editedItem.subject = this.subjects.find(
        ({ id }) => id === item.subjectId
      ).description;

      this.editedItem.theoreticalExamDate = this.dateToString(
        item.theoreticalExamDate
      );
      this.editedItem.practicalExamDate = this.dateToString(
        item.practicalExamDate
      );
      this.editedItem.oralExamDate = this.dateToString(item.oralExamDate);

      console.log("this.editedItem", this.editedItem);
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = {};
      }, 300);
    },
    dateToString(value) {
      if (value) {
        return moment(String(value)).format("YYYY-MM-DD HH:mm");
      }
      return "";
    },
    createExamRegistrationPatchModel() {
      const model = {
        adminId: this.$store.state.user.id,
        //accountId: this.$store.state.account.id,
        examRegistrationId: this.editedItem.id,
        theoreticalExamDate: this.editedItem.theoreticalExamDate,
        theoryLocation: this.editedItem.theoryLocation,
        practicalExamDate: this.editedItem.practicalExamDate,
        practicalLocation: this.editedItem.practicalLocation,
        oralExamDate: this.editedItem.oralExamDate,
        oralLocation: this.editedItem.oralLocation,
        theoryEvaluatorId: this.editedItem.theoryEvaluatorId,
        theoryMark: this.editedItem.theoryMark,
        practicalEvaluatorId1: this.editedItem.practicalEvaluatorId1,
        practicalMark1: this.editedItem.practicalMark1,
        practicalEvaluatorId2: this.editedItem.practicalEvaluatorId2,
        practicalMark2: this.editedItem.practicalMark2,
        practicalEvaluatorId3: this.editedItem.practicalEvaluatorId3,
        practicalMark3: this.editedItem.practicalMark3,
        practicalEvaluatorId4: this.editedItem.practicalEvaluatorId4,
        practicalMark4: this.editedItem.practicalMark4,
        practicalEvaluatorId5: this.editedItem.practicalEvaluatorId5,
        practicalMark5: this.editedItem.practicalMark5,
        oralEvaluatorId1: this.editedItem.oralEvaluatorId1,
        oralMark1: this.editedItem.oralMark1,
        oralEvaluatorId2: this.editedItem.oralEvaluatorId2,
        oralMark2: this.editedItem.oralMark2,
        oralEvaluatorId3: this.editedItem.oralEvaluatorId3,
        oralMark3: this.editedItem.oralMark3,
        theoreticalGraceMark: this.editedItem.theoreticalGraceMark,
        oralGraceMark: this.editedItem.oralGraceMark,
        graceMark: this.editedItem.graceMark,
        markEntryUserId: this.$store.state.user.id,
        isFinal: this.editedItem.isFinal,
      };

      model.theoreticalExamDate = this.dateToString(
        this.editedItem.theoreticalExamDate
      );
      model.practicalExamDate = this.dateToString(
        this.editedItem.practicalExamDate
      );
      model.oralExamDate = this.dateToString(this.editedItem.oralExamDate);

      return model;
    },
  },
};
